import { interfacePrefix, uploadServiceUrl } from '@/config'
import { getHead, isJSON } from '@/utils'
import axios from 'axios'


const walletWithhold2State = {
  TO_BE_CONFIRMED: 0,
  OPENED: 1,
  TERMINATED: 2,
  UNOPENED: 99,
}


export default {
  data() {
    return {
      columnLabelWidth: '80px',
      columnSeparator: ': ',
      uploadCommonTip: 'OCR图片格式限制为1MB，非ocr图片限制大小10MB',
      // 新能源组件表格的配置信息
      newTableComponentOptions: {
        // 能源表格组件表格的表头颜色，白色
        headerBackground: {
          backgroundColor: 'rgb(255,255,255)',
        },
        // 能源表格组件分页所在的位置，居右
        paginationAlign: 'right',
      },
    }
  },
  computed: {
    allResource() {
      return this.$store.getters.allResource || []
    },
    uploadServiceUrl() {
      if (window.location.hostname === 'localhost') {
        return uploadServiceUrl
      }
      if (Number.isInteger(window.location.hostname.split('.')[0] - 0)) {
        return uploadServiceUrl
      }
      return window.location.origin
    },
  },
  methods: {
    /**
     * 字典转列表，用于select下拉列表等场景
     * @param {*} obj  Object 原对象 JSON格式
     * @param 第二个参数为选填 不填默认解析JSON的keys生成数组，对应value,label
     *第二个参数支持两种情况
      1. Boolean值 默认会在JSON解析基础后数组，添加数组第一项，默认{value:'',label:'全部'}
      2. JSON对象 若第一项需要自定义，可直接传递对象进行解析，如{value:-1,label:'全部车辆'}
     */
    dictParseList(obj) {
      const keys = Object.keys(obj)
      const arr = []
      for (let i = 0; i < keys.length; i++) {
        arr.push({
          value: parseInt(keys[i], 10),
          label: obj[keys[i]],
        })
      }

      const param2 = arguments[1]
      if (param2) {
        const type = (typeof param2).toUpperCase()
        if (type === 'BOOLEAN') {
          arr.unshift({
            value: '',
            label: '全部',
          })
        } else if (param2 instanceof Object) {
          if (Object.keys(param2).length) {
            arr.unshift({
              value: param2.value,
              label: param2.label,
            })
          }
        }
      }
      return arr
    },
    /**
     * ztw 过滤上传组件的fileList杂乱数据，例如组件自动添加的reponse属性
     * @param {*} data 当前组件绑定的fileList对应数组 isParseString是否转成字符串 默认是true false则返回处理过的数据数组
     * @returns 返回是过滤后的数组并且转成字符串
     */
    getUoloadCommonFileData(data, isParseString = true, method = 'unshift') {
      if (data && data.length) {
        const arr = []
        data.forEach((item) => {
          // 过滤fileList Url为空情况
          if (item.url) {
            arr[method](item.url)
          }
        })

        if (arr.length) {
          if (isParseString) {
            return JSON.stringify(arr)
          } else {
            return arr
          }
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    /**
     * 用于上传回显时处理数据,解析后端数据
     * @param {*} key
     * @returns 数组
     */
    getEchoUploadFileData(data, needName = false) {
      let cacheArr = [] // 中间数据
      const output = [] // 带name的数据
      if (!data) return cacheArr
      // json数据
      if (isJSON(data)) {
        cacheArr = JSON.parse(data)
      }
      // 自身传参数就是array
      if (Array.isArray(data)) {
        cacheArr = [...data]
      }
      if (!Array.isArray(cacheArr)) return []

      for (let i = 0; i < cacheArr.length; i++) {
        const item = cacheArr?.[i]
        if (typeof item === 'string') {
          // 针对 [""] 单条数据进行判断
          if (cacheArr.length <= 1 && !item) continue
          output.push({ name: this.getFileName(item), url: item, status: 'success' })
          continue
        }
        // if (Array.isArray(item) && item.length >= 1) {
        if (Array.isArray(item)) {
          output.push(item[0] || {})
          continue
        }

        if (item?.url) {
          output.push({
            name: item?.name ? item.name : this.getFileName(item?.url),
            url: item?.url || '',
            status: 'success',
          })
          continue
        }
      }
      if (needName) return output // 带name
      return cacheArr // 不带name
    },
    formatEnumeration(arr) {
      const list = {}
      arr.forEach((item) => {
        list[item.code] = item.name
      })
      return list
    },
    judgePermission(key) {
      if (!key) return false
      return this.allResource.includes(key)
    },
    checkBankChannelPermission(pingAnKey, wangShangKey, channelType) {
      // channelType 6-平安银行 8-网商银行
      if (channelType === 6) {
        return this.judgePermission(pingAnKey)
      }
      return this.judgePermission(wangShangKey)
    },
    publicUpload(file, headers = {}) {
      const formData = new FormData()
      formData.append('file', file)
      return axios({
        url: `${interfacePrefix}/fs/upload`,
        method: 'POST',
        data: formData,
        headers: {
          ...headers,
          ...getHead(this.$store),
        },
      })
    },

    /**
     * 获取处理后的数据属性
     * 统一处理图片数据
     * 如果[]取第1个的attr值
     * data是数据源，不确定什么格式，先尝试转JSON，然后尝试获取
     * arrt是属性值，比如取url, title string格式
     */
    getProcessingDataAttrValue(data, attr = 'url') {
      try {
        const _data = JSON.parse(data)
        if (_data instanceof Object) {
          if (Array.isArray(_data)) {
            if (_data.length) {
              return _data[0][attr]
            }
          } else {
            return _data[attr]
          }
        } else {
          return ''
        }
      } catch (error) {
        return ''
      }
    },

    // 验证值是否是为空的，如Null '' undefined
    validateIsEmptyValue(val) {
      if (val === null || val === '' || val === undefined) {
        return true
      } else {
        return false
      }
    },
    // 保留两位补0 + 千分位转换
    numberWithCommas(x) {
      if (!x) return '0.00'
      // 保留两位补 0
      let value = Math.round(parseFloat(x) * 100) / 100
      const s = value.toString().split('.')
      if (s.length === 1) {
        value = `${value.toString()}.00`
      }
      if (s.length > 1) {
        if (s[1].length < 2) {
          value = `${value.toString()}0`
        }
      }
      // 千分位
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    // 获取文件名称
    // /xxx.png
    // /xxx.png?key=xxxx/ssssss
    // download?key=sssss.png
    // download?key=sssss.aaa.png
    getFileName(data) {
      if (!data || typeof data !== 'string') return ''
      // 有query 判断0 是否含有后缀 如果有我将以这个为名称
      const query = data.split('?')?.pop()
      const case1 = data.split('?')?.shift()
      const lastPath = case1.split('/')?.pop()
      if (lastPath && lastPath.lastIndexOf('.') !== -1) {
        return lastPath
      }

      // 将data.split('/') 取最后一个 如果这个有 将是合法名称 如果
      const lastPath2 = query.split('/')?.pop()
      if (lastPath2 && lastPath2.lastIndexOf('.') !== -1) {
        return lastPath2
      }
      // const name = typeof data === 'string' && data.slice(data.lastIndexOf('/') + 1)?.split('?')[0]
      return ''
    },
    getURL({ data, defaultImg, needName = false }) {
      const defaultValue = defaultImg || (needName ? [] : null)
      if (!data) return defaultValue
      // 判断http、https 或者 相对路径  'htttp:// || /'
      if (typeof data === 'string' && (data.indexOf('http') === 0 || data.startsWith('/'))) {
        if (needName) return [{ name: this.getFileName(data), url: data, status: 'success' }]
        return data
      } else if (typeof data === 'string') {
        // ['']
        const result = this.getEchoUploadFileData(data, needName)
        if (needName) return result
        else return result?.[0] || defaultValue
      } else {
        return defaultValue
      }
    },
    // 发起签约检测网约钱包支付是否开启和司机是否签署弹窗
    checkSignAlipayWithhold(row, callback) {
      const h = this.$createElement
      if (
        row.dayAndWeekWalletWithhold === null
        ||
        row.dayAndWeekWalletWithhold.status === walletWithhold2State.UNOPENED
        || row.dayAndWeekWalletWithhold.status === walletWithhold2State.TERMINATED
      ) {
        return this.$msgbox({
          title: '签约支付宝支付',
          message: h('div', {}, [
            h('div', { style: 'margin-bottom: 10px' }, '网约钱包支付未开启，无法签约支付宝支付，请先完成网约钱包支付签约!'),
            h('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.$msgbox.close()
                  this.showOpenWalletWithhold(row)
                },
              },
            }, ' >>点此立即签署网约钱包支付'),
          ]),
          showCancelButton: false,
          confirmButtonText: '我知道了',
        })
      }

      if (row.dayAndWeekWalletWithhold
        && row.dayAndWeekWalletWithhold.status === walletWithhold2State.TO_BE_CONFIRMED) {
        return this.$alert('司机还未签署网约钱包支付，请尽快联系司机完成签署网约钱包支付，签署完成后再发起支付宝支付签署', '签约支付宝支付', {
          confirmButtonText: '我知道了',
        })
      }

      callback()
    },
  },
}
